import { Component, OnInit} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../services/general.service';
import { GroupService } from '../../services/group.service';
import { ProvidersService } from '../../services/providers.service';
import {RetentionsDetailComponent} from '../retentions-detail/retentions-detail.component';
import {ModalConfirmComponent} from '../../modal-confirm/modal-confirm.component';

import * as decode from 'jwt-decode';

@Component({
  selector: 'app-retentions',
  templateUrl: './retentions.component.html',
  styleUrls: ['./retentions.component.scss']
})
export class RetentionsComponent implements OnInit {
  userId: any;
  userToken: any;
  temp = [];
  load = true;
  data: any = {};
  typeFileUpload: any;
  step = 0;
  loadBtn = false;
  listSocieties = [];
  listRetentions = [];
  retentions = [];
  total = 0;
  infoProvider: any;
  retentionsProv= [];

  retentionProv: any;

  constructor(private toastr: ToastrService, public dialog: MatDialog, private gralService: GeneralService, private groupService: GroupService, private provService: ProvidersService) {
    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    const d = this.userToken.split('Bearer ');
    const tokenPayload = decode(d[1]);
    this.userId = tokenPayload.Id;
    gralService.changeTextHead('RETENTIONSPROVIDER');
    this.getSocieties();
  }

  ngOnInit() {
  }

  getSocieties(){
    this.provService.getSociedades(this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      if(data['EsValido']){
        this.listSocieties = data['Entidades'];
      }else{
        this.listSocieties = null;
      }
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      this.listSocieties = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  search(){
    if(!this.data.NumeroProveedor || !this.data.IdSociedad){
      this.toastr.error('Favor de agregar los datos obligatorios', 'Error');
      return;
    }

    this.step = 0;
    this.listRetentions = null;
    this.temp = null;
    this.loadBtn = true;

    this.provService.searchRetentions(this.data, this.userToken).then((data) => {
      this.loadBtn = false;
      console.log(data);
      if(data['datosProveedor']){
        this.infoProvider = data['datosProveedor'];
        if(data['retencionAsignada']){
          this.retentionsProv = data['retencionAsignada'];
          console.log(data['retencionAsignada']);
        }
        this.step = 1;
        this.retentions = data['retenciones'];
      }else{
        this.toastr.info(data['lsMensajes'][0].value, 'Retenciones');
      }
    }, (err) => {
      console.log(err);
      this.step = 0;
      this.listRetentions = null;
      this.temp = null;
      this.loadBtn = false;
      this.toastr.error(err['error'][0].Response.Mensaje, 'Retenciones');
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  add(type, index ){
    let ev = 'addRetention';
    if(type == 2){
      ev = 'reaRetention';
      this.retentionProv = this.retentionsProv[index];

    }
    const dialogRef = this.dialog.open(RetentionsDetailComponent, {
      minWidth: '80%',
      position: {
        top: '6%'
      },
      data: { type: ev, retentions: this.retentions, idProveedor: this.infoProvider.idProveedor, ret: this.retentionProv }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        console.log(result);
        this.retentionsProv.push({
          idRetencion: result.assignId,
          retencion: result.assign
        });
        //this.retentionProv.retencion = 
        //this.retentionProv.idRetencion = result.assignId;
      }
    });
  }

}
